export const APP_CONSTANTS = {
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 25,
    DEFAULT_PAGE: 1,
  },
  LOADING: {
    TOAST_DELAY: 500,
  },
  TABLE: {
    DEFAULT_ICON_SIZE: 15,
  },
  UI: {
    MOBILE_BREAKPOINT: 768,
  },
};
